module.exports = __webpack_public_path__ + "img/pricetitle.1f33e55d.svg";